import React, { useState, useEffect } from "react";
//import { Button, Form, Alert } from "react-bootstrap";
import {connect, useSelector} from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment';
import Box from '@mui/material/Box';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Paper from '@material-ui/core/Paper';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import { Divider, makeStyles, useTheme, useMediaQuery} from '@material-ui/core';
import {styled} from '@mui/material/styles';
import DataTable from 'react-data-table-component';
import TextField from '@material-ui/core/TextField';
import MaterialTable from "@material-table/core";
import { ExportCsv, ExportPdf } from '@material-table/exporters';
//
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
//

import * as actions from '../store/actions/index';
//import * as actionTypes from '../store/actions/actionTypes';

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: 12,
        minWidth: 256,
        textAlign: 'center',
    },
    header: {
        textAlign: 'left',
        spacing: 10,
    },
    list: {
        padding: '20px',
    },
    button: {
        margin: theme.spacing(1),
    },
    action: {
        display: 'flex',
        justifyContent: 'space-around',
    },
}));

const StyledChip = styled(Chip)(({theme}) => ({
    fontSize: 12,
    "& .MuiChip-label":{
      padding: '2px 5px 1px'
    },
    margin: '0px',
    borderRadius: '1px',
    color: '#fff'
}));

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

function AdminTransactions(props) {
    const classes = useStyles();
    const [dataRows, setDataRows] = useState();
    const [filterText, setFilterText] = useState('');
    const [filterData, setFilterData] = useState([]);
    const theme = useTheme();
    const isSmallOrLess =
        useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(()=>{
        props.onGetAdminTransactions(props.token);
    },[]);

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    const composeTransactionMessage = (t) => {
        let desc = '';
        if ('description' in t){
            desc = ' :: ' + t.description;
        }
        let message = '';

        if (t.type === 'RECEIVED' || t.type === 'RETURNED') {
            message = t.type + ' ' + t.credits + ' credit(s)';
        } else if (t.type === 'DELETE') {
            message = t.type + ' ' + t.mac + ', ' + t.login;
        } else {
               message = t.type + ' ' + t.credits + ' credit(s), ' + t.login + desc;
        }

        return <p><b>{moment(t.created).format('MMM Do YYYY hh:mm a')}</b>: {message}</p>
    };

    let transactionsData = [];

    useEffect(() => {
        if (props.transactions && props.transactions.length){
            transactionsData = props.transactions.map((t) => {
                //console.log('inside client map', client);
                return {
                    date: moment(t.created).format('YYYY-MM-DD hh:mm a'),
                    type: t.type,
                    //mac: client.mac,
                    login: t.login,
                    credits: t.credits
                };
            });
            setDataRows(transactionsData);
            setFilterData(transactionsData);
        }
    },[props.transactions]);

    const sortIcon = <ArrowDownward />;

    const dataColumnsMaterial = [

        {
            title: 'Date',
            field: 'date',
            hidden: isSmallOrLess,
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            },

        },
        {
            title: 'Type',
            field: 'type',
            cellStyle: {
                fontSize: 13,
                padding: '6px'
            },
            render: (rowData) => {
                if (rowData.type === 'REMOVE') {
                    return <StyledChip label={rowData.type} sx={{backgroundColor: '#4caf50'}} size="small"/>;
                } else {
                    return <StyledChip label={rowData.type} sx={{backgroundColor: '#f44336'}} size="small"/>;
                }
            }
            //width: '6%'
        },
        {
            title: 'Credits',
            field: 'credits',
            cellStyle: {
                fontSize: 12,
                padding: '0px'
            },
            //width: '3%'
        },
        {
            title: 'Login',
            field: 'login',
            cellStyle: {
                fontSize: 12,
                padding: '0px',
                //overflow: 'hidden',
                //width: 10,
                //textOverflow: 'ellipsis'

            }
        }
    ];

    const dataColumns = [
        {
            name: 'Date',
            selector: 'date',
            sortable: true,
            width: '170px'
        },
        {
            name: 'Type',
            selector: 'type',
            sortable: true,
            width: 100
        },
        {
            name: 'Credits',
            selector: 'credits',
            sortable: true,
            width: '70px'
        },
        {
            name: 'Login',
            selector: 'login',
            sortable: true,
            width: 200
        }

    ];

    useEffect(() => {
        //console.log('insided useEffect', filterText);
        if (dataRows && dataRows.length){
            //console.log('filter data', clientsData);
            let data = dataRows.filter(item => {
                if(item.login && item.login.toLowerCase().includes(filterText.toLowerCase())){
                    return true;
                } else if (item.type && item.type.toLowerCase().includes(filterText.toLowerCase())) {
                    return true;
                } else {
                    return false;
                }
            });
            setFilterData(data);
        }

    }, [filterText]);

    const detailsPanel = [
        props => {
            if (!isSmallOrLess){
                return {
                    icon: () => null,
                    render: () => null
                }
            }
            
            return {
                disabled: !isSmallOrLess,
                render: (rowData) => {
                    return (
                        <Box sx={{ flexGrow: 1, padding: "5px" }}>
                        <Grid container spacing={3}>
                            <Grid item zeroMinWidth >
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <Typography sx={{fontSize: 13, fontWeight: 'bold'}} variant="h6" component="div">
                                        Date
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {rowData.rowData.date} 
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        </Box>
                    )
                }
            }
        }
        
    ];


    return (
        <Container maxWidth="xl" disableGutters={isSmallOrLess}>
            <Grid container spacing={2}>
                <Grid item md={12}></Grid>
                <Grid item md={12} sm={12} xs={12}>
                    <Paper elevation={5}>
                        <Card>
                            <CardHeader
                                title="Transactions"
                                titleTypographyProps={{
                                    fontSize: 17,
                                    fontWeight: 'bold'
                                }} 
                            />
                            <Divider variant="middle" />
                            <CardContent>
                            <MaterialTable
                                    icons={tableIcons}
                                    columns={dataColumnsMaterial}
                                    data={filterData}
                                    detailPanel={detailsPanel}
                                    title=""
                                    options={{
                                        pageSize: 10,
                                        emptyRowsWhenPaging: false,
                                        pageSizeOptions: [10, 20, 30, 40, 50, 100],
                                        padding: "dense",
                                        headerStyle: {padding: '0px', fontWeight: 'bold', fontSize: 13},
                                        tableLayout: "auto",
                                        actionsColumnIndex: -1,
                                        exportMenu: [{
                                            label: 'Export PDF',
                                            exportFunc: (dataColumnsMaterial, filterData) => ExportPdf(dataColumnsMaterial, filterData, 'myClients')
                                        }, {
                                            label: 'Export CSV',
                                            exportFunc: (dataColumnsMaterial, filterData) => ExportCsv(dataColumnsMaterial, filterData, 'myClients')
                                        }]
                                    }}

                                />
                            </CardContent>
                        </Card>
                    </Paper>
                </Grid>
            </Grid>
        </Container>

    );
}

const mapDispatchToProps = dispatch => {
    return {
        onGetAdminTransactions: (token) => dispatch(actions.getTransactionsAdmin(token))

    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        transactions: state.transactions.transactions,
        isLoadingTransactions: state.transactions.loading,
        isFailTransactions: state.transactions.error
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminTransactions);